import { writable } from "svelte/store";
import { AnalyticsApi } from "../api/AnalyticsApi";
import { RecommendationsApi } from "../api/RecommendationsApi";
const defaultState = {
    loading: true,
    selectedProductsCount: 0,
    isPreview: false,
};
const quantityMin = 1;
const quantityMax = 9999;
async function getRecommendation(set) {
    set(Object.assign(Object.assign({}, defaultState), { loading: true }));
    try {
        const searchParams = new URLSearchParams(location.search);
        const isPreview = searchParams.has("preview");
        const recommendationData = searchParams.get("id");
        if (!recommendationData) {
            location.replace("https://www.gethumankind.com/");
            return;
        }
        const [customerId, recommendationId] = recommendationData.split("|");
        const recommendationApi = new RecommendationsApi(customerId, recommendationId);
        const recommendation = await recommendationApi.getRecommendation(isPreview, false);
        if (recommendation.deleted) {
            location.replace(recommendation.brand.storeUrl);
        }
        else {
            set(Object.assign(Object.assign({}, defaultState), { loading: false, details: recommendation, isPreview }));
        }
    }
    catch (error) {
        location.replace("https://www.gethumankind.com/");
    }
}
function updateProductSelection(state, productId, selected) {
    if (state.details) {
        state.details.products = state.details.products.map(p => {
            if (p.id === productId) {
                state.selectedProductsCount += (selected ? 1 : -1) * p.quantity;
                return Object.assign(Object.assign({}, p), { selected });
            }
            return p;
        });
    }
    return state;
}
function createRecommendationStore() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { subscribe, update } = writable(defaultState, (set) => {
        void getRecommendation(set);
    });
    return {
        subscribe,
        selectAll: () => update(state => {
            if (state.details) {
                state.selectedProductsCount = 0;
                state.details.products = state.details.products.map(p => {
                    state.selectedProductsCount += p.quantity;
                    return Object.assign(Object.assign({}, p), { selected: true });
                });
            }
            return state;
        }),
        selectProduct: (productId) => update(state => updateProductSelection(state, productId, true)),
        unselectProduct: (productId) => update(state => updateProductSelection(state, productId, false)),
        updateProductQuantity: (productId, quantity) => {
            const quantityNumber = Number(quantity);
            if (Number.isNaN(quantityNumber)
                || !Number.isInteger(quantityNumber)
                || quantityNumber < quantityMin
                || quantityNumber > quantityMax) {
                // error.set(`Quantity must be a integer number between ${quantityMin} and ${quantityMax}`)
                console.log(`Quantity must be a integer number between ${quantityMin} and ${quantityMax}`);
                update(state => state);
                return;
            }
            update(state => {
                var _a;
                const product = (_a = state.details) === null || _a === void 0 ? void 0 : _a.products.find(p => p.id === productId);
                if (product === null || product === void 0 ? void 0 : product.selected) {
                    state.selectedProductsCount += quantityNumber - product.quantity;
                }
                if (product) {
                    product.quantity = quantityNumber;
                }
                return state;
            });
        },
        scrollTo: (productId, scrollTo) => update(state => {
            if (state.details) {
                const product = state.details.products.find(p => p.id === productId);
                if (product) {
                    product.scrollTo = scrollTo;
                }
            }
            return state;
        }),
        checkout: () => update(state => {
            const details = state.details;
            if (details) {
                const analyticsProducts = [];
                const selectedProductsData = [];
                for (const product of details.products) {
                    if (product.selected) {
                        selectedProductsData.push(`${product.id}:${product.quantity}`);
                        analyticsProducts.push({
                            id: product.id,
                            externalId: product.externalId,
                            quantity: product.quantity,
                            price: product.currentPrice,
                        });
                    }
                }
                const analyticsApi = new AnalyticsApi();
                const newTab = window.open("");
                void analyticsApi.triggerCustomerGoesToCheckoutFromRecommendation({
                    brandId: details.brand.id,
                    customerId: details.customer.id,
                    expertId: details.expert.id,
                    recommendationId: details.id,
                    products: analyticsProducts,
                }).then(analyticsCheckoutId => {
                    const storeCartUrl = new URL(details.brand.storeCartUrl);
                    storeCartUrl.searchParams.set("humankind-analytics-checkout", analyticsCheckoutId);
                    storeCartUrl.searchParams.set("humankind-cart", `${details.customer.id}|${details.id}#${selectedProductsData.join(",")}`);
                    if (newTab) {
                        newTab.location.href = storeCartUrl.href;
                    }
                });
            }
            return state;
        }),
        openProductPage: (product) => update(state => {
            const details = state.details;
            if (details) {
                const analyticsApi = new AnalyticsApi();
                const newTab = window.open("");
                void analyticsApi.triggerCustomerGoesToViewProductPage({
                    brandId: details.brand.id,
                    customerId: details.customer.id,
                    expertId: details.expert.id,
                    recommendationId: details.id,
                }).then(analyticsCustomerGoesToViewProductPageId => {
                    const storeProductUrl = new URL(product.url);
                    storeProductUrl.searchParams.set("humankind-product-recommendation", [
                        details.brand.id,
                        details.customer.id,
                        details.id,
                        analyticsCustomerGoesToViewProductPageId,
                    ].join("|"));
                    if (newTab) {
                        newTab.location.href = storeProductUrl.href;
                    }
                });
            }
            return state;
        }),
    };
}
export const recommendation = createRecommendationStore();
